import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pill-github',
    templateUrl: './pill-github.component.html',
    styleUrls: ['./pill-github.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PillGithubComponent implements OnInit {
    @Input() githubUrl: string;

    constructor() {}

    ngOnInit(): void {}
}
